import { IQueryParamsBaseRecord, defaultQueryParamsBase } from "common/records/index/QueryParamsBase";
import { Record } from "immutable";

export const activatedPriceListParamsFromJSON = (data: IActivatedPriceListParamsData) => {
  const record = { ...(data as any) };

  return new ActivatedPriceListParamsRecord(record);
};

export interface IActivatedPriceListParamsData extends Partial<IQueryParamsBaseRecord> {
  orgId: number;
  price_list_id: number;
}

export interface IActivatedPriceListParamsRecord extends IQueryParamsBaseRecord {
  orgId: number;
  price_list_id: number;
}

const defaultActivatedPriceListParams: IActivatedPriceListParamsRecord = {
  ...defaultQueryParamsBase,
  sort_by: "activated_price_lists.updated_at",
  sort_order: "desc",
  orgId: 0,
  price_list_id: 0,
};

export class ActivatedPriceListParamsRecord
  extends Record(defaultActivatedPriceListParams)
  implements IActivatedPriceListParamsRecord {}
